import React from "react";
import VariantSelectWithPagination from "./VariantSelectWithPagination";
import ImageZoom from "../../Const/ImageZoom";

const ProductDetails = ({
  mainState,
  setMainState,
  mainInnerState,
  setMainInnerState,
  selectedVariants,
  setSelectedVariants,
  ProductsList,
  setProductsList,
  defaultValue,
  setdefaultValue,
  inputQuery,
  setInputQuery,
  handleMultiInputChange,
  inputProduct,
  handleQuantity,
  getSubTotal,
  getDeliveryCharge,
  getGrandTotal,
  getDueAmount,
  customCharge,
  customPrice,
  setCustomPrice,
  setCustomCharge,
  Discount,
  setDiscount,
  paid,
  setpaid,
  invoice_discount_type,
  invoice_delivery_charge,
  setinvoice_delivery_charge,
  delivery_charge,
  isLoading,
  pS,
  setPs,
}) => {
  const normalizeNumber = (value, fallback = null) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const getVariantUnitPrice = (curr, variant) => {
    const directPrice = normalizeNumber(variant?.price);
    if (directPrice !== null) {
      return directPrice;
    }
    const storedPrice = normalizeNumber(mainState[curr]?.price);
    if (storedPrice !== null) {
      return storedPrice;
    }
    return 0;
  };

  const getVariantOriginalPrice = (curr, variant) => {
    const variantOriginal = normalizeNumber(variant?.calculatedMainPrice);
    if (variantOriginal !== null) {
      return variantOriginal;
    }
    const stateOriginal = normalizeNumber(mainState[curr]?.calculatedMainPrice);
    if (stateOriginal !== null) {
      return stateOriginal;
    }
    return null;
  };

  const anyVariantHasDiscount = Object.values(mainState).some((entry) => {
    if (!entry || !entry.variant || entry.variant.length === 0) {
      return false;
    }
    const variant = entry.variant[0];
    const discountType = normalizeNumber(
      variant?.discountType ?? entry?.variantDiscountType,
      null
    );
    const discountValue = normalizeNumber(
      variant?.variantDiscount ?? entry?.variantDiscountValue,
      null
    );
    return (
      discountType !== null &&
      discountValue !== null &&
      Number(discountValue) > 0
    );
  });

  return (
    <div
      className="invoice-b my-4 bg-white cat-child"
      style={{ borderTop: "0.5px solid #E0E0E0" }}
    >
      <h4 className=" my-2 mb-4 padding-main-head">Product Details</h4>
      <div className="border-p"></div>
      <div className="padding-main">
        <VariantSelectWithPagination
          handleMultiInputChange={handleMultiInputChange}
          inputProduct={inputProduct}
          ProductsList={ProductsList}
          defaultValue={defaultValue}
          setProductsList={setProductsList}
          inputQuery={inputQuery}
        />

        <div className="mt-3">
          <div
            className="rounded"
            style={{
              background: "#FAFAFA",
              display: "block",
              overflowX: "scroll",
              width: "100%",
              msOverflowStyle: "none",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <div className="variant-list">
              {Object.keys(mainState).map((curr, index) => {
                const variant = mainState[curr]["variant"][0]; // Each entry has only one variant
                const productName =
                  mainState[curr]["productName"] || curr.split("_")[0]; // Get original product name
                const unitPrice = getVariantUnitPrice(curr, variant);
                const originalPrice = getVariantOriginalPrice(curr, variant);
                const resolvedDiscountType = normalizeNumber(
                  variant?.discountType ?? mainState[curr]?.variantDiscountType,
                  null
                );
                const resolvedDiscountValue = normalizeNumber(
                  variant?.variantDiscount ??
                    mainState[curr]?.variantDiscountValue,
                  null
                );
                const hasDiscount =
                  resolvedDiscountValue !== null &&
                  resolvedDiscountValue > 0 &&
                  resolvedDiscountType !== null;
                const showOriginalPrice =
                  originalPrice !== null &&
                  originalPrice > 0 &&
                  originalPrice !== unitPrice &&
                  (hasDiscount || originalPrice > unitPrice);
                const discountLabelSuffix =
                  resolvedDiscountType === 0 ? " TK" : "%";

                return (
                  <div key={curr} className="variant-item mb-3">
                    {mainState[curr]["variant"]?.length > 0 ? (
                      <div
                        className="variant-single-row p-3"
                        style={{
                          background: "white",
                          border: "1px solid #E0E0E0",
                          borderRadius: "8px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div className="row align-items-center">
                          {/* Product Image and Name */}
                          <div className="col-3">
                            <ImageZoom
                              className="d-flex align-items-center"
                              src={!isLoading && mainState[curr]["thumb"]}
                            >
                              <img
                                width={50}
                                height={50}
                                src={!isLoading && mainState[curr]["thumb"]}
                                alt="product"
                                className="me-3 rounded shadow-sm"
                                style={{
                                  border: "0.2px solid #bcb0b0",
                                  objectFit: "cover",
                                }}
                              />
                              <div>
                                <h6 className="mb-0 text-capitalize">
                                  {productName}
                                </h6>
                                <small className="text-muted">
                                  {variant.name}
                                </small>
                                <br />
                                <small className="text-muted">
                                  SKU: {variant.name}
                                </small>
                              </div>
                            </ImageZoom>
                          </div>

                          {/* Price Input */}
                          <div className="col-2">
                            <div className="d-flex align-items-center ">
                              <div>
                                <label className="form-label small text-muted mb-1">
                                  Price
                                </label>
                                <input
                                  name="in_price"
                                  value={unitPrice}
                                  className="form-control invoiceCreateSmallInputs"
                                  placeholder="00.00"
                                  type="text"
                                  readOnly
                                />
                              </div>
                            </div>
                            <div className="d-flex align-items-center">
                              {showOriginalPrice && (
                                <small
                                  className="text-muted d-block mt-1 me-2"
                                  style={{ textDecoration: "line-through" }}
                                >
                                  {originalPrice} TK
                                </small>
                              )}
                              {hasDiscount && (
                                <small className="text-success d-block mt-1">
                                  Discount: {resolvedDiscountValue}
                                  {discountLabelSuffix}
                                </small>
                              )}
                            </div>
                          </div>

                          {/* Stock Input */}
                          <div className="col-2">
                            <label className="form-label small text-muted mb-1">
                              Stock
                            </label>
                            <input
                              name="in_stock"
                              value={Number(variant.stock)}
                              className={`form-control invoiceCreateSmallInputs${
                                Number(variant.stock) <= 0 ? " stock-out" : ""
                              }`}
                              placeholder="00.00"
                              type="text"
                              readOnly
                            />
                          </div>

                          {/* Quantity Input */}
                          <div className="col-2">
                            <label className="form-label small text-muted mb-1">
                              Quantity
                            </label>
                            <input
                              name="in_quantity"
                              onWheel={(e) => e.target.blur()}
                              onChange={(e) => handleQuantity(e, curr, variant)}
                              className="form-control invoiceCreateSmallInputs"
                              placeholder="00.00"
                              type="number"
                              value={
                                variant.quantity === -1 ||
                                variant.quantity === "-1"
                                  ? 0
                                  : variant.quantity
                              }
                            />
                          </div>

                          {/* Total Input */}
                          <div className="col-3">
                            <label className="form-label small text-muted mb-1">
                              Total
                            </label>
                            <input
                              value={isNaN(variant.total) ? 0 : variant.total}
                              className="form-control invoiceCreateSmallInputs"
                              placeholder="00.00"
                              type="text"
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center p-3">No variant</div>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="d-flex flex-column flex-md-row mt-4 justify-content-between mx-4">
              <div>
                <h6>Total Variants : {Object?.keys(mainState)?.length}</h6>
              </div>
              <div>
                <div
                  className="d-flex justify-content-between "
                  style={{
                    color: "#212121",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  <p>Sub Total :</p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss"
                      type="text"
                      value={isNaN(getSubTotal()) ? 0 : getSubTotal()}
                    />
                  </p>
                </div>

                <div className="d-flex justify-content-between cl">
                  <p>Delivery Charge : </p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss"
                      type="number"
                      onChange={(e) => setCustomCharge(Number(e.target.value))}
                      value={getDeliveryCharge()}
                      style={{ border: "1px solid gray" }}
                    />
                  </p>
                </div>
                <div className="d-flex justify-content-between pl pt-2">
                  <p>
                    <span
                      className="form-label small mb-0"
                      style={{
                        color: anyVariantHasDiscount ? "#9E9E9E" : "inherit",
                      }}
                    >
                      Discount{" "}
                      {invoice_discount_type === "0" ||
                      invoice_discount_type === 0
                        ? ""
                        : "%"}{" "}
                      :
                    </span>
                  </p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss paid_input_css"
                      name="invoice_paid"
                      type="text"
                      value={Discount}
                      onChange={(e) => setDiscount(e.target.value)}
                      disabled={anyVariantHasDiscount}
                      style={{
                        backgroundColor: anyVariantHasDiscount
                          ? "#F5F5F5"
                          : "white",
                        borderColor: anyVariantHasDiscount
                          ? "#E0E0E0"
                          : undefined,
                        color: anyVariantHasDiscount ? "#9E9E9E" : "inherit",
                        cursor: anyVariantHasDiscount ? "not-allowed" : "text",
                      }}
                    />
                  </p>
                </div>
                {setCustomPrice && (
                  <div className="d-flex justify-content-between pl pt-2">
                  <p>Custom Price :</p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss paid_input_css"
                      name="custom_price"
                      type="number"
                      min="0"
                      value={customPrice}
                      onChange={(e) => setCustomPrice(e.target.value)}
                    />
                  </p>
                </div>
                )}
                <div
                  className="d-flex justify-content-between"
                  style={{
                    color: "#212121",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  <p>Total amount :</p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss"
                      type="text"
                      value={isNaN(getGrandTotal()) ? 0 : getGrandTotal()}
                    />
                  </p>
                </div>

                <div className="d-flex justify-content-between pl pt-2">
                  <p>Paid amount :</p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss paid_input_css"
                      name="invoice_paid"
                      type="text"
                      value={paid}
                      onChange={(e) => setpaid(e.target.value)}
                    />
                  </p>
                </div>

                <div className="d-flex justify-content-between cl">
                  <p>Due amount :</p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss"
                      type="text"
                      name="invoice_due"
                      value={isNaN(getDueAmount()) ? 0 : getDueAmount()}
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
